import cashBookInstance from '../cashBook/instance'

const createCashBook = (data) => {
	return cashBookInstance.post('/cash-book/records', data)
}
export default createCashBook
